export const VIEW = {
    GALLERY: 'gallery',
    LIST: 'list',
};